import type { DocMigration } from "../docMigration";

/**
 * Defensive: move interim-branch CIP masonry components into castComponents.
 * Production docs should not have masonryType CIP.
 */
function moveInterimCipMasonryToCast(json: any): void {
  const masonryComponents = json.masonryComponents;
  if (
    masonryComponents === undefined ||
    masonryComponents === null ||
    typeof masonryComponents !== "object" ||
    Array.isArray(masonryComponents)
  ) {
    return;
  }

  if (json.castComponents === undefined || json.castComponents === null || typeof json.castComponents !== "object") {
    json.castComponents = {};
  }

  for (const componentId of Object.keys(masonryComponents)) {
    const component = masonryComponents[componentId];
    if (
      component === undefined ||
      component === null ||
      typeof component !== "object" ||
      component.masonryType !== "CIP"
    ) {
      continue;
    }

    if (json.castComponents[componentId] === undefined) {
      const thickness = typeof component.width === "number" ? component.width : 8;
      json.castComponents[componentId] = {
        entityType: "CAST_COMPONENT",
        id: componentId,
        name: typeof component.name === "string" ? component.name : `${thickness}" CIP`,
        castType: "CONCRETE",
        thickness,
        sortIndex: typeof component.sortIndex === "number" ? component.sortIndex : 0,
      };
    }
    delete masonryComponents[componentId];
  }
}

const migration: DocMigration = {
  id: "20260729_add_cast_components_doc_table",
  description:
    "Adds castComponents root table (empty; CIP has no built-ins); moves interim CIP masonry components to cast",
  apply(json: any, _warnings: string[], _errors: string[]): any {
    if (
      json.castComponents === undefined ||
      json.castComponents === null ||
      typeof json.castComponents !== "object" ||
      Array.isArray(json.castComponents)
    ) {
      json.castComponents = {};
    }

    moveInterimCipMasonryToCast(json);

    return json;
  },
};

export default migration;
